import { useTranslation } from "react-i18next";

export type Course = {
  id: number;
  price: string;
  flag: string;
  t: string;
  d: string;
  l: string[];
};

type Props = {
  course: Course;
  onSelect: (course: Course) => void;
};

export default function CourseCard({ course, onSelect }: Props) {
  const { t } = useTranslation();

  return (
    <div
      className="
        p-12 bg-white
        border border-slate-100
        rounded-[40px]
        flex flex-col justify-between
        min-h-[520px]
        transition-all duration-500
        hover:-translate-y-2
        hover:border-blue-500
        hover:shadow-[0_40px_100px_-20px_rgba(59,130,246,0.15)]
      "
    >
      {/* TOP SECTION */}
      <div className="space-y-10">

        {/* ICON + FLAG */}
        <div className="flex justify-between items-start">
          <div
            className="
              w-14 h-14
              bg-blue-50 text-blue-600
              rounded-2xl
              flex items-center justify-center
              shadow-inner
              text-xl font-black
            "
          >
            ⚡
          </div>

          {course.flag && (
            <img
              src={`https://flagcdn.com/w80/${course.flag}.png`}
              className="w-10 h-7 rounded-md shadow-sm object-cover"
              alt="flag"
            />
          )}
        </div>

        {/* TEXT */}
        <div className="text-left space-y-4">

          {/* TITLE */}
          <h3 className="text-2xl font-black uppercase tracking-tight text-slate-900 leading-tight">
            {course.t}
          </h3>

          {/* PRICE */}
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-black text-blue-600 uppercase tracking-widest">
              {t("price")}
            </span>
            <span className="text-xl font-black text-slate-900">
              {course.price}/ <span className="text-[10px] font-black text-blue-600 uppercase tracking-widest">{t("month")}</span>
            </span>
          </div>

          {/* DESCRIPTION */}
          <p className="text-sm text-slate-400 font-medium leading-relaxed italic line-clamp-3">
            {course.d}
          </p>

          {/* SYLLABUS */}
          <ul className="space-y-2 pt-2">
            {course.l?.map((item) => (
              <li
                key={item}
                className="text-xs text-slate-600 font-medium flex items-center gap-2"
              >
                <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                {item}
              </li>
            ))}
          </ul>

        </div>
      </div>

      {/* BUTTON */}
      <button
        onClick={() => onSelect(course)}
        className="
          w-full py-5 mt-12
          bg-slate-950 text-white
          font-black text-[10px]
          uppercase tracking-widest
          rounded-3xl
          shadow-lg
          hover:bg-blue-600
          transition-all
          active:scale-95
        "
      >
        {t("academy.button")}
      </button>
    </div>
  );
}